import { Button, Form, Input, Modal, Select, Space, TimePicker } from "antd";
import dayjs from "dayjs";
import { useContext, useState } from "react";
import axios from "axios";
import { NotificationInfo } from "../../../../context";
import moment from "moment";

const SetBrokenTime = ({ open, close, rerun, specificData }) => {
  const [form] = Form.useForm();
  const [timeIn, setTimeIn] = useState(null);
  const [timeOut, setTimeOut] = useState(null);
  const { rerunNotif } = useContext(NotificationInfo);

  const handleSetBrokenTime = () => {
    const formdata = new FormData();
    formdata.append(
      "merchant_id",
      specificData.merchant_id !== null ? specificData.merchant_id : ""
    );
    formdata.append(
      "user_id",
      specificData.user_id !== null ? specificData.user_id : ""
    );
    formdata.append("mes_id", specificData.id !== null ? specificData.id : "");
    formdata.append("start_datetime", timeIn);
    formdata.append("end_datetime", timeOut);

    axios
      .post("user/merchant/create/broken-time", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Set broken time successfully.");
          setTimeout(() => {
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title="Set Broken Time"
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="create-broken-time"
        initialValues={{
          start_datetime: null,
          end_datetime: null,
        }}
        onFinish={handleSetBrokenTime}
        autoComplete="off"
        form={form}
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="start_datetime"
            label="Start Time"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TimePicker
              format={"HH:mm"}
              onChange={(value, dateString) => {
                if (dateString !== "") {
                  var date = `2023-11-23 ${dateString}:00`;
                  var finalDate = moment(`${date.replace(" ", "T")}.000000Z`)
                    .utc()
                    .format("HH:mm:ss");
                  setTimeIn(finalDate);
                } else {
                  setTimeIn(null);
                }
              }}
              size="large"
              required
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="end_datetime"
            label="End Time"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TimePicker
              format={"HH:mm"}
              onChange={(value, dateString) => {
                if (dateString !== "") {
                  var date = `2023-11-23 ${dateString}:00`;
                  var finalDate = moment(`${date.replace(" ", "T")}.000000Z`)
                    .utc()
                    .format("HH:mm:ss");
                  console.log("FINAL DATE: ", finalDate);
                  setTimeOut(finalDate);
                } else {
                  setTimeOut(null);
                }
              }}
              size="large"
              required
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "10px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Set
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SetBrokenTime;
